import React, { FC } from 'react';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleMinus,
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { styled } from 'styled-components';
import { Icon } from '@/ui/components';
import { PreTimeBand } from '@/types';

const TagButton = styled.button<{
  $color: string;
  $background: string;
  $border: string;
}>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 2px 8px;
  border: 1px solid ${({ $border }) => $border};
  border-radius: 6px;
  background: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-size: 12px;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
`;

export const preTimeBandStyle: Record<
  PreTimeBand,
  { icon: IconDefinition; color: string; background: string; border: string }
> = {
  HighConfidence: {
    icon: faCircleCheck,
    color: '#067647',
    background: '#ecfdf3',
    border: '#abefc6',
  },
  NeedReview: {
    icon: faCircleExclamation,
    color: '#b54708',
    background: '#fffaeb',
    border: '#fedf89',
  },
  Manual: {
    icon: faCircleMinus,
    color: '#475467',
    background: '#f2f4f7',
    border: '#e4e7ec',
  },
};

export const PreTimeRecommendationTag: FC<{
  band: PreTimeBand;
  label: string;
  onClick: () => void;
}> = ({ band, label, onClick }) => {
  const style = preTimeBandStyle[band];
  return (
    <TagButton
      type="button"
      $color={style.color}
      $background={style.background}
      $border={style.border}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    >
      <Icon icon={style.icon} />
      {label}
    </TagButton>
  );
};
